import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import fr from 'vuetify/es5/locale/fr'
import en from 'vuetify/es5/locale/en'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#324B60',   // Bleu foncé du logo
        secondary: '#C0C0C0', // Argent (silver)
        accent: '#C0C0C0',    // Accent argent pour cohérence
        error: '#f80000',     // Inchangé
        info: '#324B60',      // Info teinté bleu foncé
        success: '#324B60',   // Succès bleu (mariage = élégance, pas vert vif)
        warning: '#f16908'    // Inchangé
      },
      dark: {
        primary: '#C0C0C0',   // Argent pour ressortir sur fond sombre
        secondary: '#324B60', // Bleu foncé en couleur secondaire
        accent: '#C0C0C0',    // Accent argent
        background: '#121921',// Bleu très sombre (lisibilité)
        surface: '#1B2733',   // Légèrement plus clair que le background
        error: '#ff4c4c',     // Rouge plus lisible sur fond sombre
        info: '#7AA4C8',      // Bleu clair lisible
        success: '#7EC8A0',   // Vert doux lisible
        warning: '#F3A45B'    // Orange doux lisible
      }

    }
  },
  lang: {
    locales: {fr, en},
    current: 'fr'
  }
});
